export const tabeebHubName = 'tabeeb'
export const spreadsheetHubName = 'spreadsheetHub'
export const healthDeviceHubName = 'healthDeviceHub'
export const autodeskHubName = 'autodeskHub'
export const aiServiceHubName = 'aiServiceHub'
